import React from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';
import { minusIcon } from '@lululemon/ecom-pattern-library-icons';
import Icon from '../icons/index';
require("./index.css");
var styles = {
  "accordionItem": "accordionItem-1CxFm",
  "accordionItemv2": "accordionItemv2-3CC_J",
  "accordionItemHeadingWrapper": "accordionItemHeadingWrapper-1-b10",
  "defaultTypeStyle-body-1": "defaultTypeStyle-body-1-macfL",
  "expanded": "expanded-3G0tl",
  "defaultTypeStyle-xsmall": "defaultTypeStyle-xsmall-xu3FE",
  "defaultTypeStyle-small": "defaultTypeStyle-small-114PX",
  "defaultTypeStyle-medium": "defaultTypeStyle-medium-3CpaE",
  "mobileTypeStyle-body-1": "mobileTypeStyle-body-1-19Awb",
  "mobileTypeStyle-xsmall": "mobileTypeStyle-xsmall-2wj4h",
  "mobileTypeStyle-small": "mobileTypeStyle-small-3P-ae",
  "mobileTypeStyle-medium": "mobileTypeStyle-medium-2oHSk",
  "accordionItemHeading": "accordionItemHeading-3bBXZ",
  "noPanel": "noPanel-2fW6T",
  "accordionItemHeadingIcon": "accordionItemHeadingIcon-oN4oZ",
  "accordionItemToggle": "accordionItemToggle-1r17a",
  "accordionItemToggleIcon": "accordionItemToggleIcon-I0m5H",
  "iconExpanded": "iconExpanded-S4qVA",
  "accordionItemPanelContent": "accordionItemPanelContent-HFI5h",
  "accordionItemPanel": "accordionItemPanel-1Xcvv",
  "accordionItemv1": "accordionItemv1-2K8Nx",
  "accordionItemLarge": "accordionItemLarge-kAIlo",
  "accordionItemMedium": "accordionItemMedium-32pDW",
  "accordionNoShadow": "accordionNoShadow-1Hdpx"
};
var ToggleIcon = _ref => {
  var {
    expanded
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: cs(styles.accordionItemToggle, {
      [styles.iconExpanded]: expanded
    })
  }, /*#__PURE__*/React.createElement(Icon, {
    className: styles.accordionItemToggleIcon,
    content: minusIcon,
    role: "img"
  }), /*#__PURE__*/React.createElement(Icon, {
    className: styles.accordionItemToggleIcon,
    content: minusIcon,
    role: "img"
  }));
};
ToggleIcon.propTypes = {
  expanded: PropTypes.bool.isRequired
};
export default ToggleIcon;